import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { cascadelist, countriesDATA, bankData, logisticsData, planArea } from './request';
export default {
  props: {
    formDataArray: {
      type: Array,
      default: () => [],
      required: true
    },
    relationData: {
      type: Array,
      default: () => [],
      required: true
    },
    dataIndex: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  watch: {
    visible(newVal) {
      this.relationModelVisible = newVal;
      this.checkedData = [];
      this.selectData = [];
      this.selectValue = [];
      this.selectOptions = [];
      if (newVal) {
        this.$nextTick(() => {
          this.echoData();
        });
      }
    },
    // data(newVal) {
    //   this.formDataArray = newVal;
    // },
    relationData(newVal) {
      this.conformData = newVal;
    },
    dataIndex(newVal) {
      this.relationModelIndex = newVal;
    }
  },
  data() {
    return {
      relationModelVisible: false,
      relationModelIndex: -1,
      // formDataArray: [],
      conformData: [],
      selectValue: [],
      selectData: [],
      isHaveRelation: false,
      checkedData: [],
      selectOptions: []
    };
  },
  computed: {
    isEmptyObject() {
      return obj => {
        return Object.keys(obj).length === 0;
      };
    }
  },
  methods: {
    echoData() {
      var _currentControl$assoc;
      let currentControl = this.formDataArray[this.relationModelIndex];
      if ((currentControl === null || currentControl === void 0 || (_currentControl$assoc = currentControl.association) === null || _currentControl$assoc === void 0 || (_currentControl$assoc = _currentControl$assoc.association) === null || _currentControl$assoc === void 0 ? void 0 : _currentControl$assoc.length) > 0) {
        this.selectValue = currentControl.association.association[0].hideControl;
        this.formDataArray.forEach(item => {
          if (item.mark === this.selectValue) {
            this.selectData = item;
          }
        });
        this.setEchoSelectOption();
        this.checkedData = currentControl.association.association[0].value;
      }
    },
    setEchoSelectOption() {
      if (this.selectData.partsType === 'dropDown') {
        let areaKey = {
          provinceFirstLevel: 1,
          province: 2,
          provinceArea: 3
        };
        if (this.selectData.type.type === 'country') {
          this.getCountryList();
        } else if (this.selectData.type.type === 'bank') {
          this.getBankList();
        } else if (this.selectData.type.type === 'logistics') {
          this.getLogisticsList();
        } else if (this.selectData.type.type === 'custom') {
          let params = {
            type: 'CUSTOM',
            controlMark: this.selectData.mark,
            is_hierarchy: true
          };
          this.getCascadelist(params);
        } else if (Object.keys(areaKey).indexOf(this.selectData.type.type) !== -1) {
          let params = {
            level: 2,
            type: 'noAll'
          };
          this.getAreaList(params);
        }
      }
    },
    // 关闭关联模态框
    closeRelation(e) {
      this.checkedData = [];
      this.selectData = [];
      this.selectValue = [];
      this.selectOptions = [];
      this.$emit('cancel', e);
    },
    // 确认
    confirmRelation(e) {
      this.saveData();
      // 最后确认时才会把当前控件的is_show改为false
      this.formDataArray[this.relationModelIndex].is_show = false;
      this.conformData = [];
      this.selectValue = [];
      this.selectData = [];
      this.isHaveRelation = false;
      this.$emit('cancel', e);
    },
    // 选择要关联的控件
    changeRelation() {
      this.formDataArray.forEach(item => {
        if (item.mark === this.selectValue) {
          this.selectData = item;
        }
      });
      // 判断当前控件的关联关系中是否有hideControl为当前mark的
      this.checkedData = [];
      if (this.selectData.partsType === 'dropDown') {
        // TODO 下拉控件 逻辑
        if (this.selectData.type.type === 'country') {
          this.getCountryList();
        } else if (this.selectData.type.type === 'bank') {
          this.getBankList();
        } else if (this.selectData.type.type === 'logistics') {
          this.getLogisticsList();
        } else if (this.selectData.type.type === 'custom') {
          let params = {
            type: 'CUSTOM',
            controlMark: this.selectData.mark,
            is_hierarchy: true
          };
          this.getCascadelist(params);
        } else if (this.selectData.type.type === 'provinceFirstLevel') {
          let params = {
            level: 1,
            type: 'noAll'
          };
          this.getAreaList(params);
        }
      }
    },
    getAreaList(params) {
      planArea(params).then(res => {
        this.selectOptions = res.map(item => {
          return {
            name: item.name,
            value: item.id
          };
        });
      });
    },
    getCascadelist(params) {
      cascadelist(params).then(res => {
        this.selectOptions = res.map(item => {
          return {
            name: item.name,
            value: item.id
          };
        });
      });
    },
    getCountryList() {
      countriesDATA({}).then(res => {
        this.selectOptions = res.map(item => {
          return {
            name: item.name,
            value: item.id
          };
        });
      });
    },
    getBankList() {
      bankData({}).then(res => {
        this.selectOptions = res.map(item => {
          return {
            name: item.name,
            value: item.id
          };
        });
      });
    },
    getLogisticsList() {
      logisticsData({}).then(res => {
        this.selectOptions = res.map(item => {
          return {
            name: item.name,
            value: item.id
          };
        });
      });
    },
    changeRelationCheckbox(partsType, name) {
      let currentControl = this.formDataArray[this.relationModelIndex];
      // 判断partsType类型 然后遍历对应的options
      if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(partsType) !== -1) {
        let findIndex = currentControl.association.association.findIndex(item => item.hideControl === this.selectValue);
        if (findIndex !== -1) {
          currentControl.association.association[findIndex]['value'] = this.checkedData;
        } else {
          let valueArr = {
            hideControl: this.selectValue,
            where1: '',
            type: 'one',
            value: this.checkedData
          };
          currentControl.association.association.push(valueArr);
        }
      }
    },
    saveData() {
      let partsType = this.selectData.partsType;
      let currentControl = this.formDataArray[this.relationModelIndex];
      // 判断partsType类型 然后遍历对应的options
      if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(partsType) !== -1) {
        let findIndex = currentControl.association.association.findIndex(item => item.hideControl === this.selectValue);
        if (this.checkedData.length === 0) {
          currentControl.association.association.splice(findIndex, 1);
          return;
        }
        if (findIndex !== -1) {
          currentControl.association.association[findIndex]['value'] = this.checkedData;
        } else {
          let valueArr = {
            hideControl: this.selectValue,
            where1: '',
            type: 'one',
            value: this.checkedData
          };
          currentControl.association.association = [valueArr];
        }
      }
    }
  }
};